import axios from "axios";
import settings from "../../settings";
axios.defaults.baseURL = settings.baseUrl;

export const getItems = ({ commit }) => {
  return new Promise((resolve, reject) => {
    axios
      .get("formtemplate")
      .then(resp => {
        const response = resp.data;
        commit("SET_ITEMS", response);
        resolve(response);
      })
      .catch(err => {
        commit("SET_ITEMS", []);
        reject(err);
      });
  });
};

// eslint-disable-next-line no-unused-vars
export const postItem = ({ commit }, data) => {
  return new Promise((resolve, reject) => {
    axios
      .post("formtemplate", data)
      .then(() => {
        resolve();
      })
      .catch(err => {
        reject(err);
      });
  });
};

// eslint-disable-next-line no-unused-vars
export const deleteItem = ({ commit }, id) => {
  return new Promise((resolve, reject) => {
    axios
      .delete("formtemplate/" + id)
      .then(() => {
        resolve();
      })
      .catch(err => {
        reject(err);
      });
  });
};

// eslint-disable-next-line no-unused-vars
export const downloadItem = ({ commit }, id) => {
  const partialUrl = "formtemplate/" + id;
  const link = document.createElement("a");
  link.href = `${settings.baseUrl}${partialUrl}`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

// eslint-disable-next-line no-unused-vars
export const getJsonItem = ({ commit }, id) => {
  return new Promise((resolve, reject) => {
    axios
      .get("formtemplate/" + id)
      .then(response => {
        resolve(response.data);
      })
      .catch(err => {
        reject(err);
      });
  });
};
